// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class TableRowClick extends WebComponent {
  didMount() {
    this.table = this.element.querySelector('table');

    this.bindRow();

    // pokud se načtou další data pomocí PU musíme jim přidat listener
    document.addEventListener('partialUpdateComplete', () => {
      this.bindRow(true);
    });
  }

  bindRow(reinit) {
    const rows = this.table.querySelectorAll('tr');

    if (reinit) {
      rows.forEach(row => {
        row.removeEventListener('click', this.rowClickHandler);
      });
    }
  
    rows.forEach(row => {
      row.addEventListener('click', this.rowClickHandler);
    });
  }

  rowClickHandler = (event) => {
    event.preventDefault();

    const row = event.currentTarget;
    const link = row.querySelector('a[data-row-click="true"]');

    // zavoláme funkci na přesměrování na detail
    if (link) {
      const url = link.getAttribute('href');
      this.href(url);
    }
  }

  href(url) {
    window.location.href = url;
  }
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TableRowClick.js